// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__74_MR","box":"WorkspacesBox_box__Ffdc8","node":"WorkspacesBox_node__3D1Al"};